import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import classnames from "classnames";

import styles from "./content-word.module.css";
import * as contentWordActions from "../../redux/actions/contentWord";
import { State } from "../../redux/store";
import { srcPath } from "../../util/Path";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { backToWeb } from "../../util/Util";

const positionArray = ["left", "middle", "right"];

const GamePage = () => {
  const dispatch = useDispatch();
  const { grade, unit, webUrl } = useSelector((state: State) => state.shared);
  const {
    answer,
    display,
    score,
    time,
    round,
    words,
    selected,
    response,
  } = useSelector((state: State) => state.contentWord);
  const [imgLoaded, addImgLoaded] = useImgLoaded(7);

  const selectAnswer = async (selected: number) => {
    await dispatch(contentWordActions.selectAnswer(selected));
    dispatch(contentWordActions.selectRound(round + 1));
  };

  useEffect(() => {
    const init = async () => {
      await dispatch(contentWordActions.initGame());
      dispatch(contentWordActions.countdown());
    };
    init();
  }, [dispatch]);

  useEffect(() => {
    if (!round || round === words.length) {
      dispatch(contentWordActions.shuffleWords());
      dispatch(contentWordActions.selectRound(0));
    }
    dispatch(contentWordActions.setAnswer());
    dispatch(contentWordActions.setDisplay());
  }, [dispatch, round, words.length]);

  return (
    <div
      className={styles.gameBoard}
      style={{ display: imgLoaded ? "block" : "none" }}
    >
      <img
        className={classnames("btn", "main-btn", "abs", styles.topRightBack)}
        src={srcPath("shared/back.png")}
        alt=""
        onLoad={addImgLoaded}
        onClick={() => backToWeb("small_book", webUrl, grade, unit)}
      />
      <div className={classnames("abs", styles.wordContainer)}>
        <img
          className={styles.wordContainerImg}
          src={srcPath("content-word/word_container.png")}
          alt=""
          onLoad={addImgLoaded}
        />
        <TransitionGroup>
          <CSSTransition
            key={answer}
            timeout={150}
            classNames={{
              enter: styles.answerEnter,
              enterActive: styles.answerEnterActive,
              exit: styles.answerExit,
              exitActive: styles.answerExitActive,
            }}
          >
            <div className={styles.wordContainerText}>{answer}</div>
          </CSSTransition>
        </TransitionGroup>
      </div>
      {positionArray.map((pos, index) => (
        <button
          key={`imgContainer-${pos}`}
          className={classnames(
            styles.imgContainer,
            styles[`imgContainer-${pos}`]
          )}
          onClick={() => selectAnswer(index)}
          disabled={selected !== null}
        >
          <img
            src={srcPath("content-word/img_container.png")}
            alt=""
            onLoad={addImgLoaded}
          />
          <TransitionGroup>
            <CSSTransition
              key={round}
              timeout={150}
              classNames={{
                enter: styles.wordImgEnter,
                enterActive: styles.wordImgEnterActive,
                exit: styles.wordImgExit,
                exitActive: styles.wordImgExitActive,
              }}
            >
              <img
                className={styles.imgContainer__img}
                src={srcPath(
                  `content-word/words/${grade}.${unit}/${grade}.${unit}_${display[index]}.png`
                )}
                style={{
                  marginTop: `${(210 / 2) * -1}px`,
                }}
                alt=""
                onLoad={addImgLoaded}
              />
            </CSSTransition>
          </TransitionGroup>
          {selected === index && (
            <img
              className={styles.imgContainer__response}
              src={srcPath(`shared/answer_${response}.png`)}
              alt=""
            />
          )}
        </button>
      ))}
      <div className={classnames("abs", styles.score)}>
        <img
          className="abs"
          src={srcPath("content-word/score.png")}
          alt=""
          onLoad={addImgLoaded}
        />
        <div className={classnames("abs", styles.infoText)}>{score}</div>
      </div>
      <div className={classnames("abs", styles.time)}>
        <img
          className="abs"
          src={srcPath("content-word/time.png")}
          alt=""
          onLoad={addImgLoaded}
        />
        <div className={classnames("abs", styles.infoText)}>{time}</div>
      </div>
    </div>
  );
};

export default GamePage;
